import { useState, useCallback, useEffect } from 'react';
import getCaseActivityLog, { CaseActivityEntry } from 'api/cases/getCaseActivityLog';
import useNotificationProvider from 'hooks/notificationBar/useNotificationProvider';

function useCaseActivityLog(caseId: number | null) {
  const [activities, setActivities] = useState<CaseActivityEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const { notifyError } = useNotificationProvider();

  const fetchActivities = useCallback(async () => {
    if (!caseId) return;
    setLoading(true);
    try {
      const data = await getCaseActivityLog(caseId);
      // Sort by date descending (most recent first)
      data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      setActivities(data);
    } catch (error) {
      console.error('[useCaseActivityLog] Failed to fetch activities:', error);
      notifyError('Failed to fetch case activity log');
    } finally {
      setLoading(false);
    }
  }, [caseId, notifyError]);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return { activities, loading, refetch: fetchActivities };
}

export default useCaseActivityLog;
